import React, { useContext } from 'react';
import classnames from 'classnames';
import { Portal } from '../Portal';
import { Backdrop } from '../../components/Backdrop';
import { OverlayContext } from '../../utilities/OverlayContext';
export const Overlay = ({ animate, backdrop, children, onClose, open, portal, }) => {
    const context = useContext(OverlayContext);
    /*
     * Short circuit component so DOM order is correct.
     * See Nesting Order Check story in Storybook.
     * The Modal should be visibly on top of the Drawer, and the Overlay containing it should be second in DOM order.
     */
    if (!open)
        return null;
    const OverlayClassNames = classnames('Overlay', {
        'Overlay--is-portalled': portal,
        'Overlay--is-open': open,
        'Overlay--has-animation': animate,
        'Overlay--has-backdrop': backdrop,
    });
    return (React.createElement(Portal, { conditional: portal },
        React.createElement("div", { className: OverlayClassNames },
            backdrop && (React.createElement(Backdrop, { animate: animate, onClick: onClose, open: open })),
            React.createElement(OverlayContext.Provider, { value: context.concat('Overlay') }, children))));
};
//# sourceMappingURL=Overlay.js.map